export const SIGN_IN_URL = 'https://wallet.vpag.com/signin';

export const SIGN_UP_URL = 'https://wallet.vpag.com/signup';
